var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdsButton',_vm._g(_vm._b({attrs:{"loading":_vm.$store.state.isLoading,"secondary":"","button-text":"Submit for review"}},'AdsButton',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }